import { Button, Card } from '@/components'
import * as Feather from 'react-feather'
import { Text } from '@/components'
import { AlertMessage, ConfigurableButton } from '@/app/components'
import { LoadingAnimation } from '@/components'
import Tabs from '@/components/Tabs'
import { pointsToDollars } from '../../rewards.utils'

interface RedeemRewardCardProps {
  transactions: any[]
  pageLoading: boolean
  availablePoints: number
  setPointsRedemptionModalOpen: (open: boolean) => void
}

export default function RedeemRewardCard(props: RedeemRewardCardProps) {
  return (
    <Card className="w-full">
      <div className="w-full h-full flex flex-col items-center gap-8">
        <div
          id="points_display"
          className="flex flex-col items-center justify-center"
        >
          <div className="flex flex-col items-center">
            {props.pageLoading ? (
              <LoadingAnimation type="falling" />
            ) : (
              <>
                <div className="flex flex-row items-center gap-2">
                  <Text
                    variant="h1"
                    id="available-points"
                    className="text-themed-primary mb-1"
                    data-availablepoints={props.availablePoints}
                  >
                    ${pointsToDollars(props.availablePoints)}
                  </Text>
                </div>
                <Text variant="body4">Current reward balance</Text>
              </>
            )}
          </div>
        </div>
        <div id="button_container" className="flex flex-row gap-4 w-full">
          <Button
            id="redeem_button"
            className="flex flex-1"
            onClick={() => props.setPointsRedemptionModalOpen(true)}
          >
            <div className="flex flex-row gap-2 items-center">
              <Feather.Award className="w-4 h-4" />
              Redeem
            </div>
          </Button>
          <Button
            id="earn_button"
            variant="primary-subtle"
            className="flex flex-1"
            onClick={() => Tabs.setActiveTabIndex('reward-tabs', 0)}
          >
            <div className="flex flex-row gap-2 items-center">
              <Feather.Zap className="w-4 h-4" />
              Earn
            </div>
          </Button>
        </div>
      </div>
    </Card>
  )
}
